import React from 'react';
import EditGeneralSettingComponent from '../../../Components/GeneralSetting/EditGeneralSetting';

export default function EditGeneralSetting() {
    return (
        <div className='page-body'>
            <EditGeneralSettingComponent />
        </div>
    );
}